<div class="profile__wrapper">
  <div class="salary_wrapper">
    <div class="d-flex justify-content-between">
      <h2 class="title mt-0">Salary</h2>
      <app-dropdown
      class="period-dropdown"
      [items]="increaseStatusOptions"
      [formControl]="salaryStatusControl"
      [border]="'none'"
      *ngIf="isAbleToView"
    ></app-dropdown>
    </div>

    <ng-container *ngIf="isAbleToView; else noAbleToView">
      <app-table
        *ngIf="dataSalary.length; else noSalary"
        [headers]="headersSalary"
        [content]="dataSalary"
      ></app-table>
      <ng-template #noSalary>
        <div class="profile__nodata">
          There is no increase history for the selected period
        </div>
      </ng-template>
      <button
        *ngIf="isAllowedSalaryIncrease"
        class="button button__add--normal table__btn"
        type="button"
        (click)="openPopUp()"
      ></button>
    </ng-container>

    <ng-template #noAbleToView>
      <div class="profile__nodata">
        This employee is from another department/unit, so his increase info is
        not available
      </div>
    </ng-template>
  </div>

  <div *ngIf="isAccountantDepartment">
    <label
      class="button button__save button__save__topRight"
      (click)="redirectToSalaryIncreases()"
    >
      <span class="plus">+ </span>
      <span>Salary Details</span>
    </label>
  </div>

  <h2 class="title">Accumulated vacation days</h2>
  <app-table
    *ngIf="dataVacation.length; else noVacation"
    [tableType]="'material'"
    [headers]="headersVacation"
    [content]="dataVacation"
    [showEditFields]="true"
    [editLastTwoRows]="true"
    [editMenu]="'icon'"
    (rowAction)="showDialog($event)"
  ></app-table>
  <ng-template #noVacation>
    <div class="profile__nodata">
      There is no accumulated vacation history for that employee
    </div>
  </ng-template>
</div>
